// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-page-js" + "-" + "e43b5a72d0c1907f09e6" + ".js";
};